import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AdminPanelService } from '../../services/admin-panel.service';
import { APIUrl } from '../../app-service-routing';

@Component({
  selector: 'app-transactions',
  templateUrl: './transactions.component.html',
  styleUrls: ['./transactions.component.scss']
})
export class TransactionsComponent implements OnInit {
  usedcards: any = [];
  constructor(private router: Router, private service: AdminPanelService) { }

  ngOnInit() {
    this.transactionlisting();
  }

  transactiondetail(d) {
    this.service.setSelectedTransactionsDetail(d);
    this.router.navigate(['home/transactiondetails/' + d.productID]);
  }

  transactionlisting() {
    this.service.getReseultSetList(APIUrl.transaction).subscribe(response => {
      this.usedcards = response;
    }, error => {
    });
  }


}
